// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__EB5yE","notes":"Notes_notes__RAU2N","note":"Notes_note__3fRho","markdown":"Notes_markdown__ypz8i"};